import clsx from 'clsx';
import React, { forwardRef } from 'react';
import { clampText as clampTextClass } from './clamp-text.module.css';
export const ClampText = forwardRef(({ className, children, rows = 1, style, ...props }, forwardedRef) => {
    const cssVars = {
        '--rows': rows,
    };
    return (React.createElement("span", { ref: forwardedRef, style: { ...cssVars, ...style }, className: clsx(clampTextClass, className), ...props }, children));
});
ClampText.displayName = 'ClampText';
